import React, { FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import PrimaryButton from "Shared/Buttons/PrimaryButton";
import CheckIcon from "src/components/icons/Check";
import styled from "styled-components";
import { Vin } from "Types/api/Vehicle";
import { AccountState, VehicleState } from "Types/state";
import FlyoutListItem from "./FlyoutListItem";

const StyledCheckIcon = styled(CheckIcon)`
    color: ${(props) => props.theme.palette.primary.main};
    height: 12px;
    margin-right: 5px;
    width: 16px;
`;

const Title = styled("h3")`
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
`;

const Header = styled("div")`
    align-items: center;
    display: flex;
    padding: 30px 15px 10px;
`;

const List = styled("ul")`
    max-height: 265px;
    overflow: auto;
`;

const Footer = styled("div")`
    padding: 10px 15px 30px;
`;

interface FlyoutListProps {
    account: AccountState;
    isAuthed: boolean;
    onViewGarage: (vin?: Vin) => void;
    vehicles: VehicleState[];
}

const FlyoutList: FunctionComponent<FlyoutListProps & WithTranslation> = ({
    account,
    isAuthed,
    vehicles,
    onViewGarage,
    t,
}) => {
    const handleToggleGarage = () => onViewGarage();

    return (
        <div>
            <Header>
                <StyledCheckIcon />
                <Title>{t("FlyoutGarage.FlyoutList.title")}</Title>
            </Header>
            <List>
                {vehicles.map((vehicle: VehicleState) => (
                    <FlyoutListItem
                        account={account}
                        vehicle={vehicle}
                        key={vehicle.vin}
                        onOpenGarage={handleToggleGarage}
                    />
                ))}
            </List>
            {isAuthed && (
                <Footer>
                    <PrimaryButton onClick={handleToggleGarage}>
                        {t("FlyoutGarage.FlyoutList.viewMyGarage")}
                    </PrimaryButton>
                </Footer>
            )}
        </div>
    );
};

export default withTranslation()(FlyoutList);
